import { gql } from '@apollo/client'

export const RESEND_INVITE = gql`
    mutation ResendInvite($input: inviteToEventInput!) {
        inviteToEvent(input: $input) {
            event {
                ... on Event {
                    guid
                }
            }
            status {
                item
                status
            }
        }
    }
`

export const DELETE_INVITED = gql`
    mutation RemoveInvited($input: deleteEventAttendeesInput!) {
        deleteEventAttendees(input: $input) {
            entity {
                guid
            }
        }
    }
`
